module.exports = __webpack_public_path__ + "img/gray-info.fd81dc44.svg";